/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { useMixpanel } from 'gatsby-plugin-mixpanel';

import Header from './header';
import './layout.css';

const Layout = ({ children }) => {
  const mixpanel = useMixpanel();

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <>
      <div
        style={{
          position: 'relative',
          height: '100px',
          width: '100%',
          backgroundColor: '',
          color: 'white!important',
        }}
      >
        <Header siteTitle={data.site.siteMetadata.title} />
      </div>
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          padding: `0px 1.0875rem 1.45rem`,
          paddingTop: 0,
        }}
      >
        <main>{children}</main>
        <footer className="classic">
          <a
            href="/"
            onClick={() => mixpanel.track('Load map', { kingdom: 'default', trigger: 'Logo' })}
          >
            Back to the Pollinator Project
          </a>{' '}
          &middot; Created by @nicktobolski &nbsp; for the{' '}
          <span role="img" aria-label="world">
            🌍
          </span>{' '}
          with
          <span role="img" aria-label="heart">
            ❤
          </span>{' '}
        </footer>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
